var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_207)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.9998 115C121.171 115 138.333 97.8375 138.333 76.6666C138.333 55.4957 121.171 38.3333 99.9998 38.3333C78.8289 38.3333 61.6665 55.4957 61.6665 76.6666C61.6665 97.8375 78.8289 115 99.9998 115Z",
    fill: "#B52F2F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17_207",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 188,
    height: 188
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9998 193.333C151.546 193.333 193.333 151.547 193.333 100C193.333 48.4535 151.546 6.66675 99.9998 6.66675C48.4533 6.66675 6.6665 48.4535 6.6665 100C6.6665 151.547 48.4533 193.333 99.9998 193.333Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17_207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.9998 259.247C137.739 259.247 168.333 228.654 168.333 190.914C168.333 153.175 137.739 122.581 99.9998 122.581C62.2604 122.581 31.6665 153.175 31.6665 190.914C31.6665 228.654 62.2604 259.247 99.9998 259.247Z",
    fill: "#B52F2F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_207"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile1);
export default __webpack_public_path__ + "static/media/profile1.9f5dd0a761f47d0f0e734f54e65e7088.svg";
export { ForwardRef as ReactComponent };